export default ({ axios, mapQueryString }) => ({
    index: (branch, query = {}) => axios.get(`/branches/${branch}/goods${mapQueryString(query)}`),
    import: (branch, file) => axios.post(`/branches/${branch}/goods/import`, file)
})


// WEBPACK FOOTER //
// ./src/api/branchGoods.js